export const Height = {
    header:60,
    subheader: 60,
    footer: 58
}


// export default Height;



